export class cAccountLogin {
  customerLogin      = document.querySelector('#customer_login') as HTMLElement | null;
  buttonShowRegister = document.querySelector('#c-show-register') as HTMLElement | null;
  buttonShowLogin    = document.querySelector('#c-show-login')    as HTMLElement | null;

  constructor() {
    if (!this.customerLogin) return;

    if (this.buttonShowRegister) {
      this.buttonShowRegister.addEventListener('click', (e) => {
        e.preventDefault();
        this.customerLogin?.classList.add('c-show-register-mode');
      });
    }

    if (this.buttonShowLogin) {
      this.buttonShowLogin.addEventListener('click', (e) => {
        e.preventDefault();
        this.customerLogin?.classList.remove('c-show-register-mode');
      });
    }
  }
}
